export default ($axios) => ({
  fetch(query) {
    return $axios.get('/sms/reports', { params: query }).then((response) => response.data);
  },
  download(id) {
    return $axios.get(`/sms/reports/${id}`, { responseType: 'arraybuffer' });
  },
});
